import { createApp } from 'vue';
import ResortInfo from './vue/resort-info.vue';
import { context } from './resort-info.config.yml';


const app = createApp(ResortInfo, context);
app.mount('#resort-info-root');
